import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import "../styles/Login.css";
import Logo from "../assets/Images/sm2.png";
import vsLogo from "../assets/Images/ves.png";
import fbrLogo from "../assets/Images/fbr.png";
import { postData } from "../services/Request";
import { toast } from "react-toastify";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      email: email,
      password: password,
    };
    try {
      const response = await postData("api/login", payload);

      // Check if response exists and has status property
      if (!response) {
        toast.error("No response from server");
        setLoading(false);
        return;
      }

      if (response.status === true) {
        toast.success("Login successful!");

        // Save user data in localStorage
        localStorage.setItem("user", JSON.stringify(response.user));
        localStorage.setItem("branch", JSON.stringify(response.seller));
        localStorage.setItem("token", response.token);
        setLoading(false);
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Login error:", err);

      // More specific error messages
      if (err.message && err.message.includes("Network")) {
        toast.error("Network error. Please check your connection.");
      } else if (err.response && err.response.status === 404) {
        toast.error("Invalid email or password");
      } else {
        toast.error("Login failed. Please try again later.");
      }

      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-grid">
        <section className="login-hero">
          <div>
            <img src={fbrLogo} alt="FBR Logo" className="logo" />
          </div>
          <h1 className="hero-title">Secure access for every branch.</h1>
          <p className="hero-copy">
            Stay compliant, manage quotations, and keep every sale in sync with
            FBR—all from one dashboard.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-label">Real-time</span>
              <span className="stat-value">Sync Ready</span>
            </div>
            <div className="stat-divider" />
            <div className="stat">
              <span className="stat-label">Branches</span>
              <span className="stat-value">All Linked</span>
            </div>
          </div>
        </section>

        <section className="login-card">
          <div className="logos">
            <img src={Logo} alt="Logo" className="logo1" />
            <img src={vsLogo} alt="VestonCore" className="logo" />
          </div>

          <div className="login-headline">
            <p className="eyebrow">Welcome back</p>
            <h2 className="title">Sign in to continue</h2>
            <p className="subtitle">
              Use your branch email and password to access the portal.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="field">
              <label className="field-label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input"
              />
            </div>

            <div className="field">
              <label className="field-label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input"
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? <CircularProgress size={22} /> : "Log In"}
            </button>
          </form>

          <p className="login-help">
            Trouble signing in? Contact your branch admin to reset your access.
          </p>
        </section>
      </div>
    </div>
  );
}
